<template>
  <div class="full_page">
    <div class="row">
      <div class="col-12">

        <template v-if="recentOrdersOnOff">
          <button @click="turnRecentOrdersOnOff()" class="button_switch_green  line_through">Recent Orders</button>
        </template>
        <template v-else>
          <button @click="turnRecentOrdersOnOff()" class="button_switch_green">Recent Orders</button>
        </template>

        <template v-if="oldOrdersOnOff">
          <button @click="turnOldOrdersOnOff()" class="button_switch_red  line_through">Older Orders</button>
        </template>
        <template v-else>
          <button @click="turnOldOrdersOnOff()" class="button_switch_red">Older Orders</button>
        </template>

        <template v-if="neverOrderedOnOff">
          <button @click="turnNeverOnOff()" class="button_switch_blue  line_through">Never Ordered</button>
        </template>
        <template v-else>
          <button @click="turnNeverOnOff()" class="button_switch_blue">Never Ordered</button>
        </template>

        <template v-if="show_dis_label">
          <button @click="turnShow_dis_label()" class="button_switch_labels">Labels</button>
        </template>
        <template v-else>
          <button @click="turnShow_dis_label()" class="button_switch_labels line_through">Labels</button>
        </template>

        <div>
          <gmap-map :center="center" :zoom="map_zoom" style='width:100%;  height:  700px;' class="gmap">

            <template v-if="show_dis_label">
              <gmap-marker
                  :key="index"
                  v-for="(m, index) in location_array"
                  :position="m.position"
                  :icon="m.icon"
                  :hidden = true
                  :label="{text: m.label, color: '#000', fontSize: '15px', fontWeight: '700'}"
                  @click="openWindow(m.id,index)"
              />
            </template>
            <template v-else>
              <gmap-marker
                  :key="index"
                  v-for="(m, index) in location_array"
                  :position="m.position"
                  :icon="m.icon"
                  :hidden = true
                  @click="openWindow(m.id,index)"
              />
            </template>

            <gmap-info-window
                @closeclick="window_open = false"
                :opened="window_open"
                :position="infowindow"
                :options="{pixelOffset: {width: 0,height: -34}}"
            >
              <div>
                <div class="map_dispansary_name">{{infotext.dis}}</div>
                <div class="map_dispansary_line">Last Order: {{infotext.lo}}</div>
                <div class="map_dispansary_line">Last Visit: {{infotext.lv}}</div>
                <div class="map_dispansary_line">NO: {{infotext.nos}}</div>
                <div>
                  <button @click="markAsVisited" class="mark_visited">Mark As Visited</button>
                  <button @click="openInNewTab" class="open_new_tab">Open In New Tab</button>
                </div>
              </div>

            </gmap-info-window>
          </gmap-map>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      center: { lat: 0.00, lng: 0.00 },
      map_zoom: 10,
      location_array: [],

      infotext: '',
      info_marker: null,
      infowindow: {lat: 0, lng: 0},
      window_open: false,

      clicked_current_id: -1,
      clicked_current_index: -1,
      clicked_customer_id: -1,

      neverOrderedOnOff: false,
      oldOrdersOnOff: false,
      recentOrdersOnOff: false,

      show_dis_label: false,
    }
  },
  computed: {
    ...mapGetters({
      ca_map_data: 'admin/ca_map_data',
      ca_map_loading: 'admin/ca_map_loading',
    }),
  },
  watch: {
    ca_map_data: async function () {
      this.setGoogleCAMap();
    },
  },
  mounted() {
    this.center.lat = 34.12;
    this.center.lng = -118.20;
    this.map_zoom = 11;
    this.get_map_data();
  },
  methods: {
    openWindow (id) {
      let clickedDispensary = [];
      this.ca_map_data.dispensaries.forEach((dispensary) => {
        if(dispensary.id === id) {
          clickedDispensary = dispensary;
        }
      });
      this.infowindow = {lat: parseFloat(clickedDispensary.lat), lng: parseFloat(clickedDispensary.lon)};
      this.infotext = clickedDispensary;
      this.clicked_current_id = id;
      this.clicked_customer_id = clickedDispensary.cid;
      this.window_open = true
    },
    get_map_data() {
      let center_lon = -118.300000;
      let center_lat = 34.0000;
      let radius = 50; // ignored now, 0.3 degrees set
      this.$store.dispatch('admin/getCAMapData', {type: 'ca_shops_json', center_lon , center_lat, radius });
    },
    markAsVisited() {
      const date = new Date();
      let day = date.getDate();
      let month = date.getMonth() + 1;
      let year = date.getFullYear();
      let internal_index = 0;
      this.ca_map_data.dispensaries.forEach((dispensary) => {
        if(dispensary.id === this.clicked_current_id) {
          this.ca_map_data.dispensaries[internal_index].lv = month+"/"+day+"/"+year;
        }
        internal_index++;
      });
      this.$store.dispatch('admin/markShopVisited', {customer_id: this.clicked_current_id});
    },
    openInNewTab() {
      const routeData = this.$router.resolve({name: 'signin', query: {customerid: this.clicked_customer_id}});
      window.open(routeData.href, '_blank');
    },
    turnNeverOnOff() {
      this.neverOrderedOnOff = this.neverOrderedOnOff !== true;
      this.setGoogleCAMap();
    },
    turnOldOrdersOnOff() {
      this.oldOrdersOnOff = this.oldOrdersOnOff !== true;
      this.setGoogleCAMap();
    },
    turnRecentOrdersOnOff() {
      this.recentOrdersOnOff = this.recentOrdersOnOff !== true;
      this.setGoogleCAMap();
    },
    turnShow_dis_label() {
      this.show_dis_label = this.show_dis_label !== true;
      this.setGoogleCAMap();
    },

    setGoogleCAMap() {
      var icon_blue = {
        url: "https://maps.gstatic.com/mapfiles/ms2/micons/blue-dot.png",
        labelOrigin: {x: 20, y: +40}
      }
      var icon_green = {
        url: "http://maps.google.com/mapfiles/ms/icons/green-dot.png",
        labelOrigin: {x: 20, y: +40}
      }
      var icon_red = {
        url: "http://maps.google.com/mapfiles/ms/icons/red-dot.png",
        labelOrigin: {x: 20, y: +40}
      }

      this.location_array = [];
      this.ca_map_data.dispensaries.forEach((dispensary) => {

        var marker = {
          lat: parseFloat(dispensary.lat),
          lng: parseFloat(dispensary.lon),
        };

        if(dispensary.t === 1 && this.neverOrderedOnOff === false) {
          this.location_array.push({position: marker, icon: icon_blue, id: dispensary.id, label: dispensary.dis})
        }
        if(dispensary.t === 2  && this.recentOrdersOnOff === false) {
          this.location_array.push({position: marker, icon: icon_green, id: dispensary.id, label: dispensary.dis})
        }
        if(dispensary.t === 3 && this.oldOrdersOnOff === false) {
          this.location_array.push({position: marker, icon: icon_red, id: dispensary.id, label: dispensary.dis})
        }
        
      });


    },
    // google.maps.event.addListener(marker, 'mouseenter', function() {
    //   console.log('Marker has been moused over.');
    // });
    // marker.content.addEventListener('mouseenter', function(){
    //   console.log('mouse enter');
    // });
    //     this.deliveries.push({position: driver_marker, icon: icon_green, label: dispensary.DBA})
  }
}
</script>

<style scoped>

.full_page {
  margin-left: 20px;
  margin-right: 20px;
}

.map_dispansary_name {
  font-size: larger;
  font-weight: 800;
  margin: 2px;
  margin-top: 0px;
}

.map_dispansary_line {
  //font-size: larger;
  font-weight: 400;
  margin: 2px;
}

.button_switch_blue {
  color: white;
  background-color: #6991fd;
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 5px;
  padding-bottom: 4px;
  border-radius: 5px;
  border-style: hidden;
  font-weight: 500;
  margin-top: 10px;
  margin-bottom: 10px;
  margin-right: 10px;
}

.button_switch_green {
  color: white;
  background-color: #00e64d;
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 5px;
  padding-bottom: 4px;
  border-radius: 5px;
  border-style: hidden;
  font-weight: 500;
  margin-top: 10px;
  margin-bottom: 10px;
  margin-right: 10px;
}

.button_switch_red {
  color: white;
  background-color: #fd7467;
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 5px;
  padding-bottom: 4px;
  border-radius: 5px;
  border-style: hidden;
  font-weight: 500;
  margin-top: 10px;
  margin-bottom: 10px;
  margin-right: 10px;
}

.button_switch_labels {
  color: white;
  background-color: darkgrey;
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 5px;
  padding-bottom: 4px;
  border-radius: 5px;
  border-style: hidden;
  font-weight: 500;
  margin-top: 10px;
  margin-bottom: 10px;
  margin-right: 10px;
}

.mark_visited{
  color: white;
  background-color: darkgreen;
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 5px;
  padding-bottom: 4px;
  border-radius: 5px;
  border-style: hidden;
  font-weight: 500;
  margin-top: 10px;
  margin-bottom: 10px;
  margin-right: 10px;
}

.open_new_tab{
  color: white;
  background-color: darkorange;
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 5px;
  padding-bottom: 4px;
  border-radius: 5px;
  border-style: hidden;
  font-weight: 500;
  margin-top: 10px;
  margin-bottom: 10px;
  margin-right: 10px;
}

.line_through {
  color: black;
  text-decoration: line-through;
}
</style>
